'use client';

import React from 'react';
import { Bed, Bath, Maximize, Building2, Layers, Flame, DollarSign, Calendar, CheckCircle } from 'lucide-react';

const PROPERTY_SPECS = [
  { id: 'spec-oda', label: 'Oda Sayısı', value: '3+1', icon: <Bed size={16} className="text-primary" /> },
  { id: 'spec-banyo', label: 'Banyo', value: '2', icon: <Bath size={16} className="text-primary" /> },
  { id: 'spec-alan', label: 'Net Alan', value: '150 m²', icon: <Maximize size={16} className="text-primary" /> },
  { id: 'spec-brut', label: 'Brüt Alan', value: '172 m²', icon: <Maximize size={16} className="text-primary" /> },
  { id: 'spec-bina-yasi', label: 'Bina Yaşı', value: '4 Yıl (2022)', icon: <Building2 size={16} className="text-primary" /> },
  { id: 'spec-kat', label: 'Bulunduğu Kat', value: '8. Kat', icon: <Layers size={16} className="text-primary" /> },
  { id: 'spec-toplam-kat', label: 'Toplam Kat', value: '12 Kat', icon: <Layers size={16} className="text-primary" /> },
  { id: 'spec-isitma', label: 'Isıtma', value: 'Doğalgaz Kombi', icon: <Flame size={16} className="text-primary" /> },
  { id: 'spec-aidat', label: 'Aidat', value: '₺3.200/ay', icon: <DollarSign size={16} className="text-primary" /> },
  { id: 'spec-tapu', label: 'Tapu Durumu', value: 'Kat Mülkiyeti', icon: <CheckCircle size={16} className="text-success" /> },
  { id: 'spec-iskan', label: 'İskan', value: 'Var', icon: <CheckCircle size={16} className="text-success" /> },
  { id: 'spec-kredi', label: 'Krediye Uygunluk', value: 'Uygun', icon: <CheckCircle size={16} className="text-success" /> },
  { id: 'spec-cephe', label: 'Cephe', value: 'Güney-Doğu', icon: <Calendar size={16} className="text-primary" /> },
  { id: 'spec-yapi', label: 'Yapı Tipi', value: 'Betonarme', icon: <Building2 size={16} className="text-primary" /> },
];

export default function PropertyInfo() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
      {PROPERTY_SPECS?.map((spec) => (
        <div key={spec?.id} className="card-base p-3 flex items-start gap-2.5">
          <div className="w-7 h-7 rounded-lg bg-primary-light flex items-center justify-center flex-shrink-0 mt-0.5">
            {spec?.icon}
          </div>
          <div className="min-w-0">
            <p className="text-[10px] text-muted-foreground font-semibold uppercase tracking-wide">{spec?.label}</p>
            <p className="text-sm font-bold text-foreground mt-0.5">{spec?.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}